import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=21d68500"
import script from "./PasswordChange.vue?vue&type=script&lang=js"
export * from "./PasswordChange.vue?vue&type=script&lang=js"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=21d68500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm});
